import { SimpleUser } from "@/api/types/user"

export function isMissingTeacherInfoUtil(user?: SimpleUser) {
  return (
    user?.missingTeacherProfile ||
    user?.missingTeacherAvailabilityProfile ||
    user?.missingTeacherLocations
    // TODO: deze mag niet in deze util check, zorgt ervoor dat alle zzp rollen ook naar de onboardng gaan en bij het docent deel starten terwijl ze daar niet hoeven te zijn, moet in een aparte util check voor freelance profiel
    // user?.missingFreelanceProfile
  )
}
